<div class="review-container">

  <!-- Header -->

  <div class="review-header">

    <div class="back" (click)="goBack()">
      ←
    </div>

    <div>
      <h2>Review Your Gold Coin Order</h2>
      <p>Please verify your selection before proceeding</p>
    </div>

  </div>

  <!-- Selected Coins -->

  <div class="card">

    <div class="table-header">

      <div>Coin Size</div>

      <div>Price</div>

      <div>Quantity</div>

      <div>Total Weight</div>

      <div>Total Amount</div>

    </div>

    <div
      class="table-row"
      *ngFor="let item of selectedCoins">

      <div class="coin">

        <img
          src="../../assets/images/Rectangle 1177.png">

        <span>

          {{item.weight}} g

        </span>

      </div>

      <div>

        ₹{{item.price | number:'1.2-2'}}

      </div>

      <div>

        {{item.quantity}}

      </div>

      <div>

        {{item.weight * item.quantity}} g

      </div>

      <div>

        ₹{{item.price * item.quantity | number:'1.2-2'}}

      </div>

    </div>

  </div>


  <!-- Order Summary -->

  <div class="summary-card">

    <h3>Order Summary</h3>

    <div class="summary-row">

      <span>Total Weight</span>

      <span>{{totalWeight}} g</span>

    </div>

    <div class="summary-row">

      <span>Gold Amount</span>

      <span>

        ₹{{estimatedTotal | number}}

      </span>

    </div>

    <div class="summary-row">

      <span>Making Charges</span>

      <span>

        ₹{{makingCharges | number}}

      </span>

    </div>

    <div class="summary-row">

      <span>Delivery Charges</span>

      <span class="free">

        FREE

      </span>

    </div>

    <hr>

    <div class="summary-row grand">

      <span>

        Grand Total

      </span>

      <span>

        ₹{{grandTotal | number:'1.2-2'}}

      </span>

    </div>

  </div>


  <!-- Buttons -->

  <div class="buttons">

    <button
      class="back-btn"
      (click)="goBack()">

      Back

    </button>

    <button
      class="place-btn"
      (click)="placeOrder()">

      Place Order

    </button>

  </div>

</div>